/* File: frontend/src/pages/CasesPage.js */
/* Version: 1.4 (quick-260913-1f7 — развилка арендатора, ветка fitenko на общем слое) */
/* Date: 2026-09-13 */
/* Description:
   - [NEW]: Added "+ New Case" button (navigates to /cases/new).
   - [NEW]: Added Delete Action (Trash icon) with confirmation dialog.
   - [UI]: Updated layout to match "Platinum" design standards.
   - [1f7]: РАЗВИЛКА АРЕНДАТОРА В ЭТОМ ЖЕ ФАЙЛЕ, а не форк экрана. Форк завёл бы
     ВТОРОГО держателя удаления дела: две копии текста подтверждения и две копии
     обработки ошибки, которым нечем разойтись, разошлись бы МОЛЧА. Обе ветки
     зовут ОДНИ И ТЕ ЖЕ обработчики; легаси-ветка не тронута ни байтом, и это
     проверяется sha256 (приёмка П4б).
   - [1f7]: классы ветки fitenko — СВОИ (`fk-dela-*`). Оставить легаси-классы
     значило бы оставить и все 20 зашитых цветов CasesPage.css на пути fitenko:
     правила там БЕЗ рубежа арендатора и применяются ко всем четырём.
*/

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import { Trash2, Plus, Search, RefreshCw } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useBranding } from '../context/BrandingContext';
import { ShapkaSKnopkoy } from '../components/FitenkoUzor';
import './CasesPage.css';

const CasesPage = () => {
    const navigate = useNavigate();
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Фильтры поиска
    const [searchParams, setSearchParams] = useState({
        case_number: '',
        client_last_name: ''
    });

    // Загрузка дел
    const fetchCases = async () => {
        setLoading(true);
        try {
            const hasParams = searchParams.case_number || searchParams.client_last_name;
            let data;
            
            if (hasParams) {
                data = await apiService.searchCases(searchParams);
            } else {
                data = await apiService.getCases();
            }
            
            setCases(data || []);
        } catch (error) {
            console.error("Error fetching cases:", error);
            // Не показываем ошибку, если просто нет данных
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCases();
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        fetchCases();
    };

    const handleReset = () => {
        setSearchParams({ case_number: '', client_last_name: '' });
        apiService.getCases().then(data => setCases(data || []));
    };

    // --- Удаление дела ---
    const handleDeleteCase = async (id, caseNumber) => {
        if (window.confirm(`Are you sure you want to delete case ${caseNumber}? This cannot be undone.`)) {
            try {
                await apiService.deleteCase(id);
                toast.success(`Case ${caseNumber} deleted`);
                setCases(prev => prev.filter(c => c.id !== id));
            } catch (error) {
                toast.error("Failed to delete case");
            }
        }
    };

    // --- Переход к созданию ---
    const handleNewCase = () => {
        navigate('/cases/new');
    };

    // 🔴 РУБЕЖ АРЕНДАТОРА СТОИТ ПОСЛЕ ПОСЛЕДНЕГО ХУКА, и это не вкус: порядок
    //    хуков React обязан быть ОДИН на каждой отрисовке, а признак арендатора
    //    приходит асинхронно (BrandingContext). Рубеж выше `useEffect` дал бы
    //    разный порядок хуков до и после ответа — прямое предупреждение
    //    Dashboard.js:99 и LeadsPage.js:248.
    const { isFitenko } = useBranding();

    // ─── ВЕТКА fitenko: узлы ОБЩЕГО СЛОЯ и свои классы fk-dela-* ───
    // Обработчики — ТЕ ЖЕ САМЫЕ. Ни одной копии логики здесь нет.
    if (isFitenko) {
        return (
            <div className="fk-page fk-dela">
                <ShapkaSKnopkoy
                    nadzagolovok="CASES"
                    zagolovok="Case Management"
                    podstroka="Cases, their clients and current status."
                    podpis="New Case"
                    naZhatie={handleNewCase}
                />

                <form className="fk-dela-poisk" onSubmit={handleSearch}>
                    <label className="fk-dela-pole-metka">
                        Case Number
                        <input
                            type="text"
                            className="fk-dela-pole"
                            placeholder="e.g., IM-00001"
                            value={searchParams.case_number}
                            onChange={(e) => setSearchParams({...searchParams, case_number: e.target.value})}
                        />
                    </label>
                    <label className="fk-dela-pole-metka">
                        Client Last Name
                        <input
                            type="text"
                            className="fk-dela-pole"
                            placeholder="e.g., Smith"
                            value={searchParams.client_last_name}
                            onChange={(e) => setSearchParams({...searchParams, client_last_name: e.target.value})}
                        />
                    </label>
                    <div className="fk-dela-deystviya">
                        <button type="button" className="fk-dela-act-vtor" onClick={handleReset}>Reset</button>
                        <button type="submit" className="fk-dela-act">Search</button>
                    </div>
                </form>

                <section className="fk-dela-svod">
                    {loading ? (
                        <p className="fk-dela-sostoyanie">
                            <RefreshCw className="fk-dela-vrashchenie" /> Loading cases...
                        </p>
                    ) : (
                        <table className="fk-dela-tablica">
                            <thead>
                                <tr>
                                    <th className="fk-dela-shapka-yacheyka">Case Number</th>
                                    <th className="fk-dela-shapka-yacheyka">Title</th>
                                    <th className="fk-dela-shapka-yacheyka">Client</th>
                                    <th className="fk-dela-shapka-yacheyka">Status</th>
                                    <th className="fk-dela-shapka-yacheyka">Created At</th>
                                    <th className="fk-dela-shapka-yacheyka fk-dela-vpravo">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cases.length > 0 ? (
                                    cases.map((c) => (
                                        <tr key={c.id} className="fk-dela-stroka" onClick={() => navigate(`/cases/${c.id}`)}>
                                            <td className="fk-dela-yacheyka fk-dela-nomer">
                                                {c.case_number}
                                            </td>
                                            <td className="fk-dela-yacheyka">{c.title}</td>
                                            <td className="fk-dela-yacheyka">{c.client ? `${c.client.first_name} ${c.client.last_name}` : (c.client_name || 'N/A')}</td>
                                            <td className="fk-dela-yacheyka">
                                                <span className={`fk-dela-znachok fk-dela-znachok-${c.status?.toLowerCase() || 'open'}`}>
                                                    {c.status || 'Open'}
                                                </span>
                                            </td>
                                            <td className="fk-dela-yacheyka">{new Date(c.created_at).toLocaleDateString()}</td>

                                            <td className="fk-dela-yacheyka fk-dela-vpravo">
                                                <button
                                                    type="button"
                                                    className="fk-dela-udalit"
                                                    onClick={(e) => { e.stopPropagation(); handleDeleteCase(c.id, c.case_number); }}
                                                    title="Delete Case"
                                                >
                                                    <Trash2 size={18} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="fk-dela-yacheyka fk-dela-pusto">No cases found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </section>
            </div>
        );
    }

    // Phase 07.1 Wave 2: page wrapper tokenized; search inputs use bg-popover+border-input;
    // CTA button uses bg-primary. Case rows are tokenized in CSS via Wave 1 var() consumers.
    return (
        <div className="cases-page-container bg-background text-foreground">
            {/* Header Section */}
            <div className="cases-header">
                <h1 className="page-title text-foreground">Case Management</h1>
                <button className="btn-primary bg-primary text-primary-foreground" onClick={handleNewCase}>
                    <Plus size={18} /> New Case
                </button>
            </div>

            {/* Search Section — search-card uses bg-card surface */}
            <div className="search-section card bg-card text-card-foreground">
                <form onSubmit={handleSearch} className="search-form">
                    <div className="search-fields">
                        <div className="form-group">
                            <label className="text-muted-foreground">Case Number</label>
                            <input
                                type="text"
                                placeholder="e.g., IM-00001"
                                className="bg-popover text-foreground border border-input placeholder:text-muted-foreground"
                                value={searchParams.case_number}
                                onChange={(e) => setSearchParams({...searchParams, case_number: e.target.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label className="text-muted-foreground">Client Last Name</label>
                            <input
                                type="text"
                                placeholder="e.g., Smith"
                                className="bg-popover text-foreground border border-input placeholder:text-muted-foreground"
                                value={searchParams.client_last_name}
                                onChange={(e) => setSearchParams({...searchParams, client_last_name: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="search-actions">
                        <button type="button" className="btn-secondary bg-muted text-foreground" onClick={handleReset}>Reset</button>
                        <button type="submit" className="btn-primary search-btn bg-primary text-primary-foreground">Search</button>
                    </div>
                </form>
            </div>

            {/* Table Section — bg-card surface, status badges remain semantic */}
            <div className="cases-table-container card bg-card text-card-foreground">
                {loading ? (
                    <div className="loading-state">
                        <RefreshCw className="spin-animation" /> Loading cases...
                    </div>
                ) : (
                    <table className="cases-table">
                        <thead>
                            <tr>
                                <th>Case Number</th>
                                <th>Title</th>
                                <th>Client</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th style={{textAlign: 'right'}}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.length > 0 ? (
                                cases.map((c) => (
                                    <tr key={c.id} onClick={() => navigate(`/cases/${c.id}`)}>
                                        <td className="case-number-cell">
                                            {c.case_number}
                                        </td>
                                        <td>{c.title}</td>
                                        <td>{c.client ? `${c.client.first_name} ${c.client.last_name}` : (c.client_name || 'N/A')}</td>
                                        <td>
                                            <span className={`status-badge status-${c.status?.toLowerCase() || 'open'}`}>
                                                {c.status || 'Open'}
                                            </span>
                                        </td>
                                        <td>{new Date(c.created_at).toLocaleDateString()}</td>
                                        
                                        <td style={{textAlign: 'right'}} className="action-cell">
                                            <button 
                                                className="icon-button delete-btn" 
                                                onClick={(e) => { e.stopPropagation(); handleDeleteCase(c.id, c.case_number); }}
                                                title="Delete Case"
                                            >
                                                <Trash2 size={18} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="no-data">No cases found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default CasesPage;